// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Transactions_tableWrapper__4w5NY","checkedStatus":"Transactions_checkedStatus__UYu1-"};